import $ from 'jquery';
import { setCookie, getCookie } from 'utils/cookies';

const notification = () => {
    // Check if we have notification on the page
    const $notification = $('.s-notification');
    if (!$notification.length) { return; }

    // We have notificastion, then carry on
    const $closeBtn = $notification.find('.close-icon');
    const cookieName = `hide-notification-${$notification.attr('id')}`;
    const cookie = getCookie(cookieName);
    const expiryData = $notification.attr('data-expiry-type');

    if (cookie === '') {
        $notification.removeClass('hide');
    } else {
        $notification.addClass('hide');
    }

    $closeBtn.click(() => {
        $notification.addClass('hide');
        setCookie(cookieName, 1, expiryData);
    });
};

$(() => {
    notification();
});



// WEBPACK FOOTER //
// ./src/sections/notification/s-notification.js